import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';

// From M-UI
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
// import EmailIcon from '@material-ui/icons/Email';

function About() {
    const [open, setOpen] = React.useState(false);

    return (
        <Grid container>
            <h2 className='nav'>
                <span className='hover-underline-animation'>
                    <Link to='/'>HOME</Link>
                </span>
            </h2>
            <Grid container className='aboutPage'>
                <Grid item lg={4} sm={12} className='aboutWeb'>
                    <h1>ABOUT</h1>
                    <h5>THE WEBSITE</h5>
                </Grid>

                <Grid item lg={8} sm={12} className='paragraph'>
                    <p>
                        It is a simple website, but it had to exist at some point.<br />
                        Yening said, "Let there be a website," and so there was.<br /><br />
                        I had wanted to build this site for a long time. Somehow, I kept putting it off—partly out of laziness, and partly because I had no idea what to put on it.<br />
                        Now, I finally do.<br />
                        This is where I collect the projects I am working on, along with the ideas I hope to bring to life someday.<br />
                        More importantly, it is proof that I was here—that I made things, explored ideas, and left something behind.
                    </p>
                </Grid>

                <Grid item lg={4} sm={12} className='aboutMe'>
                    <h1>ABOUT</h1>
                    <h5>YENING WANG</h5>
                </Grid>

                <Grid item lg={8} sm={12} className='paragraph'>
                    <p>
                        A programmer. <br />
                        A designer. <br />
                        A husband. <br />
                        A gamer. <br />
                        A happy guy. <br />
                        ... <br /><br />

                        I play many roles in life.<br />
                        But if I had to describe myself in one word, it would be '<b>thinker</b>'—though I am probably not as deep in thought as The Thinker.<br />
                        The more I think, the more interesting life—and the world around me—becomes. <br /><br />

                        I also love Coca-Cola.<br />
                        Once, I conducted a very serious experiment: a blind taste test with two bottles—one Coca-Cola and one Pepsi—placed in a random order. <br />
                        Naturally, as a devoted Coca-Cola fan, I identified them correctly. <br /><br />

                        Oh, and one more thing: my favorite ice cream is called <span
                            onClick={() => setOpen(true)}
                            className="moonMistDes"
                        >
                            Moon Mist
                        </span>, and it is especially popular in Nova Scotia. <br />
                        <s>I hope Island Farms brings it back to BC someday.</s><br />
                        Thanks to Chapman's, you can now get Moon Magic—their name for Moon Mist ice cream—at Wholesale Club.
                    </p>



                </Grid>
                <Grid item lg={4} sm={12} className='contactInfo'>
                    <h1>CONTACT</h1>
                    <h5>INFORMATION</h5>
                </Grid>

                <Grid item lg={8} sm={12} className='paragraph'>
                    <h3 style={{ marginBottom: 0 }}>ELECTRONIC MAIL ADDRESS:</h3>
                    <div className='emailSpan'>
                        <span
                            onClick={() => window.open("mailto:yeningwang@yeningwang.com")}
                            style={{ cursor: 'pointer' }}
                        > yeningwang @yeningwang.com</span>
                    </div>
                    <h3 style={{ marginBottom: 0 }}>FOLLOW ME FOR MORE DELAYED INFORMATION: </h3>
                    <span className='webIcons'>
                        <LinkedInIcon onClick={() => window.open("https://www.linkedin.com/in/yening-wang/")} fontSize='large' />
                        <InstagramIcon onClick={() => window.open("https://www.instagram.com/fantaxy1001/")} fontSize='large' />
                    </span>
                </Grid>
                <Grid item lg={12} className='footer'>
                    <h3 style={{marginBottom: 0}}>POWERED by YENING WANG</h3>
                    <h3 style={{marginTop: 0}}>COPYRIGHT © {new Date().getFullYear()} YENING WANG</h3>
                </Grid>
            </Grid>



            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"About Moon Mist Ice Cream"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        "Moon Mist is an eye-catching, mouthwatering blend of three distinct flavors of ice cream: grape, banana, and bubblegum/blue raspberry.
                        It’s an unusual combo, to say the least.<br /><br />
                        One theory says that a flavor company shopped it around in the early 1980s, as Nova Scotian dairies started churning out the tricolored variety at roughly the same time.
                        The result was a hit in Canada’s Atlantic provinces, where it’s the most popular flavor of ice cream."
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </Grid>
    );
}

export default About;
